import { apiSlice } from '@/store/api/apiSlice';

interface PlanetSignChange {
  sign: string;
  timestamp: string;
}

export interface PlanetTransitResponse {
  planetName: string;
  sign: PlanetSignChange[];
}

export const planetSignChangesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetSignChanges: builder.query<PlanetTransitResponse[], void>({
      query: () => ({
        url: '/transits/planet-sign-changes',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPlanetSignChangesQuery } = planetSignChangesApi;
